
import { serializable, alias, object, list, primitive } from 'serializr';


class UserRole {
	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;
}

export class User {

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('name', primitive()))
	name?: string;

	@serializable(alias('position', primitive()))
	position?: string;

	@serializable(alias('email', primitive()))
	email?: string;

	@serializable(alias('phone', primitive()))
	phone?: string;

	@serializable(alias('extension', primitive()))
	extension?: string;

	@serializable(alias('status', primitive()))
	status?: string;

	@serializable(alias('role', primitive()))
	role?: string;

	@serializable(alias('brand', primitive()))
	brand?: string;

	@serializable(alias('association', primitive()))
	association?: string;

	@serializable(alias('user_role', object(UserRole)))
	userRole?: UserRole;

	@serializable(alias('company_id', primitive()))
	companyId?: object;

	@serializable(alias('createdAt', primitive()))
	createdAt?: string;

	@serializable(alias('updatedAt', primitive()))
	updatedAt?: string;

}